import {
  createFocusOutlineStyle,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
export const useSuggestedAppTileStyles = makeStyles({
  cardFocusIndicator: createFocusOutlineStyle({
    selector: "focus",
    style: {
      outlineWidth: "2px",
      outlineOffset: "-2px",
      outlineColor: tokens.colorStrokeFocus2,
    },
  }),
  suggestedAppTileRoot: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("4px"),
    width: "100%",
    height: "64px",
    alignItems: "center",
  },
  suggestedAppTile: {
    ...shorthands.borderRadius("4px"),
    ...shorthands.borderStyle("none"),
    paddingTop: "0px",
    paddingBottom: "0px",
    boxShadow: "none",
    ":hover": {
      backgroundColor: tokens.colorNeutralBackground1Hover,
      boxShadow: "none",
    },
    "&:active:hover": {
      backgroundColor: tokens.colorNeutralBackground1Pressed,
      boxShadow: "none",
    },
  },
  suggestedAppTileRootReversed: {
    flexDirection: "column-reverse",
  },
  suggestedAppTileContentWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    ...shorthands.padding("4px", "0px", "2px", "0px"),
    ...shorthands.gap("5px"),
    width: "100%",
    height: "100%",
    ...shorthands.borderRadius("4px"),
  },
  suggestedAppTileInfoContainer: {
    display: "flex",
    flexDirection: "row",
    ...shorthands.gap("12px"),
    width: "245px",
    height: "56px",
  },
  appIconWrapper: {
    width: "32px",
  },
  appIcon: {
    width: "32px",
    height: "32px",
    marginTop: "6px",
    ...shorthands.borderRadius("6px"),
    ...shorthands.border("1px", "solid", tokens.colorNeutralStroke2),
    color: tokens.colorNeutralForeground3,
  },
  appContext: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    ...shorthands.gap("4px"),
    width: "201px",
  },
  appContextTitle: {
    display: "block",
    textAlign: "left",
    width: "201px",
    height: "20px",
    lineHeight: tokens.lineHeightBase300,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    ...shorthands.overflow("hidden"),
  },
  appContextDescription: {
    display: "block",
    textAlign: "left",
    width: "201px",
    height: "16px",
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase100,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
    ...shorthands.overflow("hidden"),
  },
  appContextLinksContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "12px",
    ...shorthands.padding("0", "0", "2px"),
    ...shorthands.gap("5px"),
    lineHeight: "6px",
  },
  appContextLinkWrapper: {
    maxWidth: "63px",
    textAlign: "left",
    ...shorthands.overflow("hidden"),
    paddingRight: "5px",
  },
  appContextLinkWrapperWithBorder: {
    ...shorthands.borderRight("1px", "solid", tokens.colorNeutralStroke1Hover),
  },
  appContextLink: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    ":hover": {
      color: tokens.colorNeutralForeground3,
      textDecorationColor: tokens.colorNeutralForeground3,
    },
  },
  appContextLinkLabel: {
    display: "block",
    height: "12px",
    lineHeight: "8px",
    fontSize: tokens.fontSizeBase100,
  },
  suggestedAppTileActionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...shorthands.gap("10px"),
    width: "47px",
    height: "56px",
  },
  suggestedAppTileActionButton: {
    width: "53px",
    minWidth: "53px",
    height: "24px",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "8px",
    paddingLeft: "0",
    paddingRight: "0",
    whiteSpace: "nowrap",
    ...shorthands.borderRadius("4px"),
  },
  suggestedAppTileActionButtonLabel: {
    maxWidth: "40px",
    fontWeight: tokens.fontWeightSemibold,
    ...shorthands.overflow("hidden"),
  },
});
